import { useDispatch } from 'react-redux';
import { 
  showAlert, 
  showSuccessAlert, 
  showInfoAlert, 
  showWarningAlert, 
  handleError,
  removeAlert
} from '../store/features/alertSlice';

export const useAlerts = () => {
  const dispatch = useDispatch();

  return {
    showAlert: (message, options) => dispatch(showAlert(message, options)),
    showSuccess: (message, options) => dispatch(showSuccessAlert(message, options)),
    showInfo: (message, options) => dispatch(showInfoAlert(message, options)),
    showWarning: (message, options) => dispatch(showWarningAlert(message, options)),
    showError: (error) => dispatch(handleError(error)),
    removeAlert: (id) => dispatch(removeAlert(id))
  };
}; 